import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Plus, Trash2 } from 'lucide-react';
import { v4 as uuidv4 } from 'uuid';

export default function ParentTabEditor({ data, onChange }) {
  if (!data) return null;

  const updateField = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const addIntroItem = () => {
    const newList = [...(data.intro_list || []), ''];
    updateField('intro_list', newList);
  };

  const updateIntroItem = (index, value) => {
    const newList = [...data.intro_list];
    newList[index] = value;
    updateField('intro_list', newList);
  };

  const removeIntroItem = (index) => {
    const newList = data.intro_list.filter((_, i) => i !== index);
    updateField('intro_list', newList);
  };

  const addCommitteeMember = () => {
    const newTable = [...(data.committee_table || []), {
      name: '',
      designation: '',
      membership: ''
    }];
    updateField('committee_table', newTable);
  };

  const updateCommitteeMember = (index, field, value) => {
    const newTable = [...data.committee_table];
    newTable[index] = { ...newTable[index], [field]: value };
    updateField('committee_table', newTable);
  };

  const removeCommitteeMember = (index) => {
    const newTable = data.committee_table.filter((_, i) => i !== index);
    updateField('committee_table', newTable);
  };

  return (
    <div className="space-y-6 bg-white p-6 rounded-lg border">
      {/* Header Title */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Header Title
        </label>
        <Input
          value={data.header_title || ''}
          onChange={(e) => updateField('header_title', e.target.value)}
          placeholder="e.g., CISH ITMU / IPR Cell"
        />
      </div>

      {/* Header Description */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Header Description (HTML)
        </label>
        <Textarea
          value={data.header_description || ''}
          onChange={(e) => updateField('header_description', e.target.value)}
          placeholder="<p>Description...</p>"
          rows={4}
        />
      </div>

      {/* Intro List */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <label className="block text-sm font-medium text-gray-700">
            Key Functions List
          </label>
          <Button onClick={addIntroItem} size="sm" variant="outline">
            <Plus className="w-4 h-4 mr-1" /> Add Item
          </Button>
        </div>
        <div className="space-y-2">
          {data.intro_list && data.intro_list.map((item, index) => (
            <div key={index} className="flex gap-2">
              <Input
                value={item}
                onChange={(e) => updateIntroItem(index, e.target.value)}
                placeholder="Key function..."
              />
              <Button
                onClick={() => removeIntroItem(index)}
                size="sm"
                variant="destructive"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Committee Table */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <label className="block text-sm font-medium text-gray-700">
            ITMU Committee Members
          </label>
          <Button onClick={addCommitteeMember} size="sm" variant="outline">
            <Plus className="w-4 h-4 mr-1" /> Add Member
          </Button>
        </div>
        <div className="space-y-4">
          {data.committee_table && data.committee_table.map((member, index) => (
            <div key={index} className="border rounded p-4 bg-gray-50">
              <div className="grid md:grid-cols-3 gap-3 mb-3">
                <div>
                  <label className="text-xs text-gray-600 mb-1 block">Name</label>
                  <Input
                    value={member.name}
                    onChange={(e) => updateCommitteeMember(index, 'name', e.target.value)}
                    placeholder="Dr. Name"
                  />
                </div>
                <div>
                  <label className="text-xs text-gray-600 mb-1 block">Designation</label>
                  <Input
                    value={member.designation}
                    onChange={(e) => updateCommitteeMember(index, 'designation', e.target.value)}
                    placeholder="Director, ICAR-CISH"
                  />
                </div>
                <div>
                  <label className="text-xs text-gray-600 mb-1 block">Membership</label>
                  <Input
                    value={member.membership}
                    onChange={(e) => updateCommitteeMember(index, 'membership', e.target.value)}
                    placeholder="Chairman"
                  />
                </div>
              </div>
              <Button
                onClick={() => removeCommitteeMember(index)}
                size="sm"
                variant="destructive"
              >
                <Trash2 className="w-4 h-4 mr-1" /> Remove Member
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
